import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { loginRequest } from '@/auth/msal';

export function SignInPage() {
  const { instance } = useMsal();
  const [busy, setBusy] = useState(false);

  const signIn = () => {
    setBusy(true);
    instance.loginRedirect(loginRequest).catch(() => setBusy(false));
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#040f1d] text-[#e7eef6] px-4">
      <div className="w-full max-w-sm rounded-xl border border-[#19395a] bg-[#0a1f35] p-8 shadow-2xl text-center">
        <div className="mx-auto w-14 h-14 grid place-items-center rounded-2xl bg-[#0e2942] border border-[#1d4067] mb-5">
          <ShieldCheck className="w-8 h-8 text-[#e8472b]" />
        </div>
        <h1 className="text-xl font-bold leading-tight">AI Security &amp; Compliance Hub</h1>
        <p className="text-[13px] text-[#8fa1b8] mt-2 mb-7">
          Sign in with your Microsoft Entra ID work account to access the dashboard.
        </p>
        <button
          onClick={signIn}
          disabled={busy}
          className="w-full flex items-center justify-center gap-2.5 rounded-md bg-[#2563eb] hover:bg-[#1d4ed8] disabled:opacity-60 px-4 py-2.5 text-[14px] font-semibold transition-colors"
        >
          {busy ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <svg className="w-4 h-4" viewBox="0 0 21 21" aria-hidden="true">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
          )}
          Sign in with Microsoft
        </button>
        <p className="text-[11px] text-[#637891] mt-5">
          Single sign-on secured by Microsoft Entra ID
        </p>
      </div>
    </div>
  );
}
